window.initMarkUpTip = function() {
  console.log("[initMarkUpTip] Attempting to initialize markup tooltip script...");

  var checkInterval = setInterval(function() {
    var tooltipToggle = document.getElementById('mu-tooltip-toggle');
    var tooltip = document.getElementById('mu-tooltip');
    var markupInput = document.getElementById('mu-markup-input');
    var tooltipSave = document.getElementById('mu-tooltip-save');
    var tooltipClose = document.getElementById('mu-tooltip-close');

    if (tooltipToggle && tooltip && markupInput && tooltipSave && tooltipClose) {
      clearInterval(checkInterval);
      console.log("[initMarkUpTip] All required elements found. Initializing...");

      var initialVal = markupInput.value;
      var filterDebounce = false;

      async function updateCustomerMarkup(value) {
        console.log("[initMarkUpTip] Updating customer markup with value:", value);
        var endpoint = "https://script.google.com/macros/s/AKfycbybKEPDAY9cCYaVdmxZIuTW4W6-Gz860Ks9evmd8e8Jw5tiqksad9e0SlZEzzrpplxq/exec";
        var params = new URLSearchParams();
        params.append("customer_id", window.customerId || "");
        params.append("selection", value);
        var urlToFetch = endpoint + "?" + params.toString();
        console.log("[initMarkUpTip] Sending update to:", urlToFetch);
        
        tooltipSave.innerHTML = '<span class="mu-spinner"></span>';
        tooltipSave.disabled = true;
        
        try {
          const response = await fetch(urlToFetch);
          const json = await response.json();
          console.log("[initMarkUpTip] Response:", json);
          location.reload();
        } catch (err) {
          console.error("[initMarkUpTip] Error sending data to Apps Script:", err);
          location.reload();
        }
      }

      tooltipToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        if (filterDebounce) return;
        filterDebounce = true;
        setTimeout(() => filterDebounce = false, 300); // 300ms debounce

        console.log("[initMarkUpTip] Tooltip toggle clicked.");
        console.log("[initMarkUpTip] Current tooltip classes:", tooltip.className);
        
        var rect = tooltipToggle.getBoundingClientRect();
        tooltip.style.top = '-100px';
        tooltip.style.left = '0px';

        if (tooltip.classList.contains('mu-tooltip-hidden')) {
          tooltip.classList.remove('mu-tooltip-hidden');
          tooltip.classList.add('mu-tooltip-visible');
          console.log("[initMarkUpTip] Tooltip set to visible.");
        } else {
          tooltip.classList.remove('mu-tooltip-visible');
          tooltip.classList.add('mu-tooltip-hidden');
          console.log("[initMarkUpTip] Tooltip set to hidden.");
        }
        
        console.log("[initMarkUpTip] New tooltip classes:", tooltip.className);
      });

      tooltipClose.addEventListener('click', function(e) {
        e.stopPropagation();
        tooltip.classList.remove('mu-tooltip-visible');
        tooltip.classList.add('mu-tooltip-hidden');
      });

      tooltipSave.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!tooltipSave.disabled) {
          var newValue = markupInput.value;
          updateCustomerMarkup(newValue);
        }
      });

      tooltip.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      markupInput.addEventListener('input', function(e) {
        tooltipSave.disabled = (markupInput.value === initialVal);
      });

      console.log("[initMarkUpTip] Markup tooltip initialized.");
    }
  }, 100);
};

document.addEventListener('DOMContentLoaded', function() {
  console.log("[DOMContentLoaded] DOM fully loaded. Initializing vendor show stock.");
  window.initMarkUpTip();
});
